"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.higherContrastTextColorHsl = void 0;
var color_constants_1 = require("../../color-constants");
var contrast_ratio_1 = require("./contrast-ratio");
var higherContrastTextColorHsl = function (hsl) {
    var contrastWhite = (0, contrast_ratio_1.contrastRatioHsl)(color_constants_1.whiteHsl, hsl);
    var contrastBlack = (0, contrast_ratio_1.contrastRatioHsl)(hsl, color_constants_1.blackHsl);
    return contrastWhite < contrastBlack ? 'black' : 'white';
};
exports.higherContrastTextColorHsl = higherContrastTextColorHsl;
